import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }

    const sessionId = match[1];

    const exchangeSession = async () => {
      try {
        const response = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) throw new Error("Auth failed");

        const user = await response.json();

        // Store session for API calls
        localStorage.setItem("google_session", user.session_token);
        localStorage.setItem("google_user", JSON.stringify(user));

        // If admin, also set admin token for existing admin functionality
        if (user.role === "admin") {
          localStorage.setItem("admin_token", user.session_token);
        }

        // Clean URL and redirect
        window.history.replaceState(null, "", window.location.pathname);

        if (user.role === "admin") {
          navigate("/panel050623", { replace: true, state: { user } });
        } else {
          navigate("/bestill", { replace: true, state: { user } });
        }
      } catch (error) {
        console.error("Auth error:", error);
        navigate("/", { replace: true });
      }
    };

    exchangeSession();
  }, [navigate]);

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      height: "100vh", background: "#1a0a05", color: "#d4af37",
      fontFamily: "Arial, sans-serif"
    }}>
      <div style={{ textAlign: "center" }}>
        <div style={{
          width: 40, height: 40, border: "3px solid #d4af37",
          borderTopColor: "transparent", borderRadius: "50%",
          animation: "spin 1s linear infinite", margin: "0 auto 16px"
        }} />
        <p>Logger inn med Google...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );
}
